import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { CollapseCard } from '@totalsoft/rocket-ui';
import { get, set, sequence } from '@totalsoft/change-tracking-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { emptyString } from 'constants/emptyConst';
import { CardDetailTitle } from '../../InsuranceStyles';

const CascoRisksComponent = ({ lens, color, disabled }) => {
  const { t } = useTranslation();

  return (
    <CollapseCard
      icon={PlaylistAddCheckIcon}
      iconColor={color}
      toggleOnHeaderClick
      title={
        <Tooltip title={t('Offer.Insurance.Risks')}>
          <CardDetailTitle>{t('Offer.Insurance.Risks')}</CardDetailTitle>
        </Tooltip>
      }
    >
      <Grid container spacing={1}>
        {(lens.cascoQuotation.associatedRisks |> sequence).map(risk => {
          return (
            <Grid item key={risk.id |> get} xs={12}>
              <FormControlLabel
                disabled={
                  (risk.readOnly |> get) || (risk.mandatory |> get) || (lens.sourceInsuranceQuotationId |> get) !== null || disabled
                }
                control={<Checkbox checked={risk.selected |> get} onChange={risk.selected |> set |> onCheckBoxChange} />}
                label={(risk.typeName |> get) || emptyString}
              />
            </Grid>
          );
        })}
      </Grid>
    </CollapseCard>
  );
};

CascoRisksComponent.propTypes = {
  lens: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default CascoRisksComponent;
